import { fetch } from 'http-common';

import { NotificationDetail } from 'types/api/notification.type';

interface Pageable {
  page: number;
  size: number;
  sort?: string;
}

interface NotificationFilters {
  season?: string;
  seasonLine?: string;
  title?: string;
  isPublished?: boolean;
}

export interface NotificationPostDto {
  season: string;
  seasonLine: string;
  categoryId?: string;
  italianTitle: string;
  englishTitle: string;
  italianShortDescription: string;
  englishShortDescription: string;
  italianDescription: string;
  englishDescription: string;
  isPublished: boolean;
}

class NotificationDataService {
  private http = fetch();

  private ep = '/v1/notification';

  private static buildFormData(
    notificationPostRequestDto: NotificationPostDto,
    products?: File
  ): FormData {
    const formData = new FormData();
    formData.append('season', notificationPostRequestDto.season);
    formData.append('seasonLine', notificationPostRequestDto.seasonLine);
    if (notificationPostRequestDto.categoryId) {
      formData.append('categoryId', notificationPostRequestDto.categoryId);
    }
    formData.append('italianTitle', notificationPostRequestDto.italianTitle);
    formData.append('englishTitle', notificationPostRequestDto.englishTitle);
    formData.append(
      'italianShortDescription',
      notificationPostRequestDto.italianShortDescription
    );
    formData.append(
      'englishShortDescription',
      notificationPostRequestDto.englishShortDescription
    );
    formData.append('italianDescription', notificationPostRequestDto.italianDescription);
    formData.append('englishDescription', notificationPostRequestDto.englishDescription);
    formData.append('isPublished', String(notificationPostRequestDto.isPublished));
    if (products) {
      formData.append('products', products);
    }
    return formData;
  }

  public async getAll(filters?: NotificationFilters, pageable?: Pageable) {
    return this.http.get(this.ep, {
      params: { ...filters, ...pageable },
    });
  }

  public async getById(id: string) {
    return this.http.get<NotificationDetail>(`${this.ep}/${id}`);
  }

  public async create(notificationPostRequestDto: NotificationPostDto, products?: File) {
    const formData = NotificationDataService.buildFormData(
      notificationPostRequestDto,
      products
    );
    return this.http.post(this.ep, formData, {
      headers: { 'Content-type': undefined } as any,
    });
  }

  public async edit(
    notificationPostRequestDto: NotificationPostDto,
    products?: File,
    id?: string
  ) {
    const formData = NotificationDataService.buildFormData(
      notificationPostRequestDto,
      products
    );
    return this.http.put(`${this.ep}/${id}`, formData, {
      headers: { 'Content-type': undefined } as any,
    });
  }

  public async delete(id: string) {
    return this.http.delete(`${this.ep}/${id}`);
  }

  public async getProductsCount(
    products: Array<{
      notificationCount: number;
      itemCode: string;
      mainFabricCode: string;
      status: string;
    }>
  ) {
    return this.http.post(`${this.ep}/products/count`, products);
  }
}

const notificationDataService = new NotificationDataService();

export { notificationDataService };
